






































import { Component, Prop, Vue } from 'vue-property-decorator';

import ImageViewerVue from './ImageViewer.vue';

import Image from '../../engine/Image';

@Component({
    components: {
        ImageViewerVue,
    },
})
export default class ImageVue extends Vue {

    @Prop() private image!: Image;
    private modal = false;

}

